import { AI_ASSISTANT_SUPPORTED_WIDGETS } from "@/constants";
import type { elementBase } from "@/elementBase/elementBase";
import type { ShapeWidget } from "@/elements/shape";
import type { stickerWidget } from "@/elements/sticker";
import type { TableWidget } from "@/elements/table/table";
import type { textWidget } from "@/elements/text/text";
import type { Group } from "@/group";
import { MIN_NUMBER_OF_SYMBOLS } from "../constants/aiConstants";
import type { AiModes } from "../types";

function isWidgetWithEnoughText(widget: elementBase): boolean {
    switch (widget.constructorName) {
        case "table": {
            let result = true;
            outer: for (const row of (widget as TableWidget).rows) {
                for (const cell of row.cells) {
                    if (cell.textPart.symbolsCount === 0) {
                        result = false;
                        break outer;
                    }
                }
            }

            return result;
        }

        case "sticker":
        case "shape":
            return (
                (widget as stickerWidget | ShapeWidget).textPart.symbolsCount >
                MIN_NUMBER_OF_SYMBOLS
            );
        case "text":
            return (widget as textWidget).symbolsCount > MIN_NUMBER_OF_SYMBOLS;
        default:
            return false;
    }
}

export function processSelectedWidgets(groups: Group[], mode: AiModes) {
    //Для включения механизма undo/redo для ai фич нужно расскоментировать строки

    const result: {
        widgetsState: {
            [UID: string]: unknown;
        };
        widgetUIDs: string[];
    } = {
        widgetUIDs: [],
        widgetsState: {},
    };

    /* const fixType = mode === "create" ? "full" : "bold"; */

    for (const group of groups) {
        if (group.isItemWrapper()) {
            if (
                AI_ASSISTANT_SUPPORTED_WIDGETS.includes(
                    (group.children[0] as elementBase).constructorName,
                ) &&
                isWidgetWithEnoughText(group.children[0] as elementBase)
            ) {
                /* result.widgetsState[group.children[0].UID] = group.children[0].getState(fixType); */
                result.widgetUIDs.push(group.children[0].UID);
            }

            continue;
        }

        (group.children as Group[]).forEach((child) => {
            if (child.isItemWrapper()) {
                if (
                    AI_ASSISTANT_SUPPORTED_WIDGETS.includes(
                        (child.children[0] as elementBase).constructorName,
                    ) &&
                    isWidgetWithEnoughText(child.children[0] as elementBase)
                ) {
                    /* result.widgetsState[child.children[0].UID] = child.children[0].getState(fixType); */
                    result.widgetUIDs.push(child.children[0].UID);
                }

                return;
            }

            (child.children as Group[]).forEach((innerChild) => {
                if (
                    AI_ASSISTANT_SUPPORTED_WIDGETS.includes(
                        (innerChild.children[0] as elementBase).constructorName,
                    ) &&
                    isWidgetWithEnoughText(innerChild.children[0] as elementBase)
                ) {
                    /* result.widgetsState[innerChild.children[0].UID] =
                        innerChild.children[0].getState(fixType); */
                    result.widgetUIDs.push(innerChild.children[0].UID);
                }
            });
        });
    }

    return result;
}
